<terra-dialog-header>
  <h1>Transaction History - {{ recipientName }}</h1>
</terra-dialog-header>

<mat-dialog-content>
  <form [formGroup]="pageForm">
    <div class="actions">
      <div class="filter-bar">
        <!-- Date -->
        <mat-form-field appearance="outline" class="text-filter-wrapper remove-error-place">
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate placeholder="Start date" formControlName="fromDate">
            <input matEndDate placeholder="End date" formControlName="toDate">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker (closed)="updateDateRange()"></mat-date-range-picker>

        </mat-form-field>
        <!-- Search -->
        <mat-form-field appearance="outline" class="text-filter-wrapper remove-error-place">
          <input matInput formControlName="filter" class="lo_sensitive" placeholder="Search" />
        </mat-form-field>
        <!-- Category -->
        <mat-form-field appearance="outline" class="remove-error-place">
          <mat-select  matInput formControlName="category" placeholder="Category">
            <mat-option [value]="0">None</mat-option>
            <mat-option *ngFor="let category of UnitPaymentCategory.listAll()" [value]="category">
              {{ category | enumString: UnitPaymentCategory }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <button *ngIf="displayClearButton$ | async" (click)="clearSearch()" mat-flat-button>
          Clear All
        </button>
      </div>
    </div>
  </form>


  <terra-unit-recipient-payments-history-display-table (repeatPayment)="repeatPayment($event.id)" [recipientId]="recipient.id">
  </terra-unit-recipient-payments-history-display-table>
</mat-dialog-content>
